import { AUTH_CONFIG, AUTH_PRODUCT_CONFIG, SAAS_AUTH_SETTINGS } from "./auth0-variables";
import React from "react";
import auth0 from "auth0-js";
import { Link, Typography } from "@material-ui/core";
import { TrialProducts } from "../material-ui/Paperbase";
import { ProductId } from "../material-ui/NavigatorData";
import { SaasAuthProductCollection } from "../material-ui/SaaSContent";


export interface AuthenticationDataSaas {
  refresh_token: string
  expires_at: string,
  id_token: string,
}

export interface SaasProductResultdata {
  [ProductId.ccS1000D]: AuthenticationDataSaas | null,
  [ProductId.ccJATS]: AuthenticationDataSaas | null, 
  [ProductId.ccBITS]: AuthenticationDataSaas | null,
  [ProductId.ccNISOSTS]: AuthenticationDataSaas | null,
  [ProductId.ccXSLFO]: AuthenticationDataSaas | null
}

export interface AuthSaasInterface {
  downloadAuthResult: SaasProductResultdata;
  download: (product: TrialProducts, tokenData: AuthenticationDataSaas) => void
  isAuthenticationExpired: (expiresIn: number) => boolean;
}

export class SaasAuth implements AuthSaasInterface {
  public isResultLoaded = {
    [ProductId.ccS1000D]: false,
    [ProductId.ccJATS]: false,
    [ProductId.ccBITS]: false,
    [ProductId.ccNISOSTS]: false,
    [ProductId.ccXSLFO]: false
  }
  public downloadAuthResult: SaasProductResultdata = {
    [ProductId.ccS1000D]: null,
    [ProductId.ccJATS]: null, 
    [ProductId.ccBITS]: null, 
    [ProductId.ccNISOSTS]: null,
    [ProductId.ccXSLFO]: null
  }

  public isError = {
    [ProductId.ccS1000D]: false,
    [ProductId.ccJATS]: false, 
    [ProductId.ccBITS]: false, 
    [ProductId.ccNISOSTS]: false,
    [ProductId.ccXSLFO]: false
  }

  public readonly downloadTokenErrorMsg =  <Typography variant="body1">Unable to access your token at this time. Please contact <Link href="mailto:support@deltaxml.com">support@deltaxml.com</Link></Typography>;
  public readonly downloadTokenDone = <Typography variant="body1">Check your Downloads to find the token file</Typography>;
  saasAuthProduct: SaasAuthProductCollection = {
    [ProductId.ccS1000D]: this.createWebAuth(ProductId.ccS1000D),
    [ProductId.ccJATS]: this.createWebAuth(ProductId.ccJATS), 
    [ProductId.ccBITS]: this.createWebAuth(ProductId.ccBITS),
    [ProductId.ccNISOSTS]: this.createWebAuth(ProductId.ccNISOSTS),
    [ProductId.ccXSLFO]: this.createWebAuth(ProductId.ccXSLFO)
  }

  public dealNumber: number = 0;

  private createWebAuth(product: TrialProducts) {
    return new auth0.WebAuth({
      domain: AUTH_CONFIG.domain,
      clientID: AUTH_PRODUCT_CONFIG[product].clientId!,
      responseType: SAAS_AUTH_SETTINGS.responseType,
      scope: SAAS_AUTH_SETTINGS.scope,
      redirectUri: AUTH_PRODUCT_CONFIG[product].callbackUrl!,
    });
  }
  

  isAuthenticationExpired(expiresIn: number) {
    const adjustedExpiresIn = (expiresIn * 1000) + new Date().getTime();
    return !(new Date().getTime() < adjustedExpiresIn);
  }
  
  download(product: TrialProducts, tokenData: AuthenticationDataSaas) {
    let token_data = `{"id": "${tokenData?.id_token}", "refresh": "${tokenData?.refresh_token}", "expiry": "${tokenData?.expires_at}"}`;
    const a = window.document.createElement('a');
    a.setAttribute('href', `data:application/json;charset=utf-8,${encodeURIComponent(token_data)}`);
    a.style.display = 'none';
    //TODO Future setAttribute dynamic depending on product
    a.setAttribute('download', AUTH_PRODUCT_CONFIG[product].downloadTokenName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  handleSwitchStateButton = async (product: TrialProducts, enableSystemActionButtons : boolean) => { 
    if (enableSystemActionButtons) {
      if (!this.isResultLoaded[product]) {
        const url = this.saasAuthProduct[product].client.buildAuthorizeUrl({
          clientID: AUTH_PRODUCT_CONFIG[product].clientId!,
          responseType: SAAS_AUTH_SETTINGS.responseType,
          scope: SAAS_AUTH_SETTINGS.scope,
          redirectUri: AUTH_PRODUCT_CONFIG[product].callbackUrl!,
          nonce: randomString(1234),
        });
        const newWindow = window.open(url + '&prompt=none', '_blank');
        if(newWindow) {
          newWindow.addEventListener('load', () => {
            newWindow.close();
          });
        } 
      }
    } else {
      // Do Nothing
    }
  }
}
function randomString(length: number) {
  let charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz+/';
  let result = '';

  while (length > 0) {
    let bytes = new Uint8Array(16);
    let random = window.crypto.getRandomValues(bytes);

    random.forEach(function (c) {
      if (length === 0) {
        return;
      }
      if (c < charset.length) {
        result += charset[c];
        length--;
      }
    });
  }
  return result;
}
const returnBrowserType = () => {
  let userAgent = navigator.userAgent;
  let browserName;
  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else {
    browserName = "No browser detection";
  }
  return browserName.toString()
}

export const SaaSAuthContext = React.createContext(new SaasAuth());
